/**
 * O MODO visual que o Ionic escolhia para o aparelho: `ios` em iPhone/iPod/iPad, `md` no resto.
 *
 * Com Ionic, o mesmo template renderiza métricas diferentes por plataforma: o `<ion-searchbar>`
 * é uma barra cinza arredondada no iPhone e um campo branco com sombra no Android e no
 * computador; o `<ion-item>` com rótulo flutuante tem 75px no iPhone e 65px no md. A
 * desionização recriou cada componente num modo só, e o QA do OP-1075 comparou no iPhone
 * (C07, C09, C47). Este módulo devolve a informação que faltava: marca o `<html>` com `ios` ou
 * `md`, exatamente como o `ionic-global.js` fazia (`classList.add(mode)` + atributo `mode`), para
 * que um componente que PRECISA divergir por plataforma use `:host-context(html.ios)` ou
 * `html.ios .x`.
 *
 * A detecção é cópia do @ionic/core 8.8.13 (`utils/platform.js`): `isIOS` = UA com
 * iPhone/iPod, ou iPad — que no iOS 13+ se apresenta como "Macintosh" e só se distingue do Mac
 * pelo ponteiro grosso (`any-pointer: coarse`). Nada mais: sem `mode` no config (a master não
 * passava) o Ionic não olhava outra coisa.
 */
export type ModoDaPlataforma = 'ios' | 'md';

export function detectarModo(win: Pick<Window, 'navigator' | 'matchMedia'>): ModoDaPlataforma {
	const ua = win.navigator?.userAgent || '';
	const ponteiroGrosso = !!win.matchMedia?.('(any-pointer:coarse)')?.matches;
	const ipad = /iPad/i.test(ua) || (/Macintosh/i.test(ua) && ponteiroGrosso);
	return /iPhone|iPod/i.test(ua) || ipad ? 'ios' : 'md';
}

/** Marca o `<html>` com o modo, como o Ionic. Idempotente. */
export function aplicarModoDaPlataforma(doc: Document = document, win: Window = window): ModoDaPlataforma {
	const modo = detectarModo(win);
	doc.documentElement.classList.remove(modo === 'ios' ? 'md' : 'ios');
	doc.documentElement.classList.add(modo);
	doc.documentElement.setAttribute('mode', modo);
	return modo;
}
